export default __webpack_public_path__ + "static/media/sun.d4595631.jpeg";